const tourSteps = (
  text,
  dispatch,
  openLoginPrompt,
  closeLoginPrompt,
  modificationsOpen,
  toggleModificationsSidebar,
  galleryTab,
  setGalleryTab,
  user
) => {
  return [
    // Getting started
    {
      disableInteract: true,
      selector: '.interactiveTourGettingStarted-0', //works reliably, but not flexible.
      header: text.interactiveTour.gettingStarted[0].title,
      content: text.interactiveTour.gettingStarted[0].content,
      moveTo: 'splash',
      //This is needed one step early, not entirely sure why
      actionAfter: () => {
        if (galleryTab.name !== 'public') {
          dispatch(setGalleryTab({ name: 'public', userInitiated: true }));
        }
      },
    },
    // Public gallery
    {
      disableInteract: true,
      selector: '.interactiveTourGettingStarted-1',
      header: text.interactiveTour.gettingStarted[1].title,
      content: text.interactiveTour.gettingStarted[1].content,
      moveTo: 'gallery',
      action: () => {
        if (galleryTab.name !== 'public') {
          dispatch(setGalleryTab({ name: 'public', userInitiated: true }));
        }
      },
      matrixFinder: publicMatrices =>
        publicMatrices.find(
          ({ name }) => name.toLowerCase() === 'MPG Grasslands'.toLowerCase()
        ),
    },
    // MPG grasslands
    {
      disableInteract: true,
      selector: '.interactiveTourGettingStarted-2',
      header: text.interactiveTour.gettingStarted[2].title,
      content: text.interactiveTour.gettingStarted[2].content,
      moveTo: 'matrix',
    },
    // Node
    {
      disableInteract: true,
      selector: '.interactiveTourGettingStarted-3',
      mutationObservables: ['.tour-node-settings'],
      highlightedSelectors: ['.tour-node-settings'],
      header: text.interactiveTour.gettingStarted[3].title,
      content: text.interactiveTour.gettingStarted[3].content,
      action: () => {
        const tourNodeClick = document.getElementsByClassName(
          'tour-node-click'
        )[0];
        if (tourNodeClick) {
          tourNodeClick.click();
        }
      },
      actionAfter: () => {
        const experimentCancel = document.getElementsByClassName(
          'tour-experiment-cancel'
        )[0];
        if (experimentCancel) {
          experimentCancel.click();
        }
      },
    },
    // Connection
    {
      selector: '.interactiveTourGettingStarted-4',
      disableInteract: true,
      header: text.interactiveTour.gettingStarted[4].title,
      content: text.interactiveTour.gettingStarted[4].content,
      action: () => {
        const connectionsButton = document.getElementsByClassName(
          'interactiveTourGettingStarted-4'
        )[0];
        if (connectionsButton) {
          connectionsButton.click();
        }
      },
    },
    // Cascade
    {
      selector: '.interactiveTourGettingStarted-5',
      disableInteract: true,
      header: text.interactiveTour.gettingStarted[5].title,
      content: text.interactiveTour.gettingStarted[5].content,
      action: () => {
        const connectionsView = document.getElementsByClassName(
          'ConnectionsView'
        )[0];
        const firstNode = connectionsView.getElementsByClassName(
          'tour-connections-node'
        )[0];

        if (firstNode) {
          firstNode.click();

          setTimeout(() => {
            const cascade = connectionsView.getElementsByClassName(
              'tour-connections-cascade'
            )[0];

            if (cascade) {
              cascade.click();
            }
          }, 300);
        }
      },
      actionAfter: () => {
        const backToTrophicLevels = document.getElementsByClassName(
          'tour-back-to-trophic-levels'
        )[0];

        if (backToTrophicLevels) {
          backToTrophicLevels.click();
        }
      },
    },
    // Matrix equilibrium
    {
      disableInteract: true,
      selector: '.MatrixChartContainer',
      mutationObservables: ['.interactiveTourGettingStarted-6'],
      highlightedSelectors: ['.interactiveTourGettingStarted-6'],
      header: text.interactiveTour.gettingStarted[6].title,
      content: text.interactiveTour.gettingStarted[6].content,
      action: () => {
        setTimeout(() => {
          window.dispatchEvent(
            new CustomEvent('tour:setSliderValue', {
              detail: { value: 1 },
            })
          );
        }, 300);
      },
      actionAfter: () => {
        const runModelButton = document.getElementsByClassName(
          'tour-run-model-button'
        )[0];
        if (runModelButton) {
          runModelButton.click();
        }
      },
    },
    // Results
    {
      disableInteract: true,
      selector: '.interactiveTourGettingStarted-7',
      header: text.interactiveTour.gettingStarted[7].title,
      content: text.interactiveTour.gettingStarted[7].content,
      actionAfter: () => {
        const compareResultsButton = document.getElementsByClassName(
          'tour-compare-results-button'
        )[0];
        if (compareResultsButton) {
          compareResultsButton.click();
        }
      },
    },
    // Comparison
    {
      disableInteract: true,
      selector: '.interactiveTourGettingStarted-8',
      header: text.interactiveTour.gettingStarted[8].title,
      content: text.interactiveTour.gettingStarted[8].content,
      actionAfter: () => {
        const backToTrophicLevels = document.getElementsByClassName(
          'tour-back-to-trophic-levels-compare'
        )[0];

        if (backToTrophicLevels) {
          backToTrophicLevels.click();
        }
      },
    },
    // Create experiment
    {
      disableInteract: true,
      selector: '.interactiveTourGettingStarted-9',
      mutationObservables: ['.MatrixSettings'],
      highlightedSelectors: ['.MatrixSettings'],
      header: text.interactiveTour.gettingStarted[9].title,
      content: text.interactiveTour.gettingStarted[9].content,
      action: () => {
        const createExperimentButton = document.getElementsByClassName(
          'interactiveTourGettingStarted-9'
        )[0];
        if (createExperimentButton) {
          createExperimentButton.click();

          setTimeout(() => {
            const carryoverCheckbox = document.getElementsByClassName(
              'tour-checkbox-carryover-experiment'
            )[0];
            if (carryoverCheckbox) {
              carryoverCheckbox.click();

              setTimeout(() => {
                const createExperiment = document.getElementsByClassName(
                  'tour-create-experiment'
                )[0];
                if (createExperiment) {
                  createExperiment.click();
                }
              }, 300);
            }
          }, 300);
        }
      },
      actionAfter: () => {
        // Note this is not actually a cancel, but the easiest way to get to the experiment we made
        const experimentCancel = document.getElementsByClassName(
          'tour-experiment-cancel'
        )[0];
        if (experimentCancel) {
          experimentCancel.click();
        }
      },
      // Happens after
      storeExperimentId: true,
    },
    // Review changes
    {
      disableInteract: true,
      selector: '.interactiveTourGettingStarted-10',
      header: text.interactiveTour.gettingStarted[10].title,
      content: text.interactiveTour.gettingStarted[10].content,
      action: () => {
        const changesFromBaseMatrix = document.getElementsByClassName(
          'tour-changes-from-base-matrix'
        )[0];
        if (changesFromBaseMatrix) {
          changesFromBaseMatrix.click();
        }
      },
      actionAfter: () => {
        if (!user) {
          const mainGallery = document.getElementsByClassName(
            'main-menu-gallery-link'
          )[0];
          if (mainGallery) {
            mainGallery.click();
          }
        }
      },
      // Happens after
      ...(!user && { deleteExperiment: true }),
    },
    ...(user
      ? [
          {
            disableInteract: true,
            selector: '.interactiveTourGettingStarted-11',
            header: text.interactiveTour.gettingStarted[11].title,
            content: text.interactiveTour.gettingStarted[11].content,
            action: () => {
              const mainGallery = document.getElementsByClassName(
                'main-menu-gallery-link'
              )[0];
              if (mainGallery) {
                mainGallery.click();
              }
              if (galleryTab.name === 'public') {
                dispatch(
                  setGalleryTab({ name: 'private', userInitiated: true })
                );
              }
            },
            deleteExperiment: true,
          },
        ]
      : []),
  ];
};

export default tourSteps;
